module.exports = __webpack_public_path__ + "static/img/卫星.37697fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/卫星.svg
// module id = 5YRo
// module chunks = 76